<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre7"><span id="pgepubid00012" title="[Pg 10]"></span></p>
<h2 class="nobreak" id="CHAPTER_II">CHAPTER II<br class="calibre16"/><br class="calibre16"/>
<span class="small">IN THE VERANDAH</span></h2>
</div>
<p class="calibre7"><span class="smcap">Before</span> the station clock
had chimed six the following morning, every soul in
the Wilkinsons' bungalow was astir. The portly head of
the house, clad in lily-white drill, and mounted on a
lily-white charger, had ambled off at daybreak, to preside
over the cantonment rations. In the long west verandah,
the bamboo blinds were already down in order to keep out
the blinding glare, and behind these "chicks" the entire
family was assembled. Three podgy, pasty-faced children
were solemnly playing at bazaar, and buying, selling, and
chaffering, in ludicrous but unconscious imitation of
their elders. The fourth was a mere spectator in the arms
of the fat ayah who with her understudy kept order among
the infants. Occasionally a shrill exclamation, a whimper,
or a howl, arose from their corner, but taking them <i class="calibre11">en
masse</i>, Beany, Pinky Tod, and Baba were unemotional
and well-behaved infants. They ate well, slept well, and
conducted themselves sedately. Nevertheless, it must be
confessed that they were not fair to see, but then we all
know that it is better to be good than beautiful. A painful
illustration of this axiom was beside them, in the shape
of their half-sister Angel, who with puckered brows and
compressed lips, was labouring away at a handsewing

<span id="pgepubid00013" title="[Pg 11]"></span>

machine, and turning out yards of faultlessly hemmed
frills. She was pretty, all the ladies said so—indeed, she
said so herself—but even the dog boy was aware that Missy
Angel was not good, did not want to be good, and made no
secret of the terrible fact. Angel assured her brothers
that it was a thousand times nicer to be wicked. She would
not eat cold curry, she refused to go to bed at seven
o'clock, she laughed at her kind papa, and sang when the
ayahs scolded her.</p>
<p class="calibre7">Not far from Angel squatted the dirzee, a thin,
grave-eyed man in spotless white clothes and turban. He
was holding a piece of muslin between two of his toes,
and cutting down a neatly marked crease with a pair of
gigantic scissors. This was Kadir Bux, a capable workman,
and Mrs. Wilkinson's much coveted treasure. Nor was Mrs.
Wilkinson herself idle, although she reclined on a long
cane lounge, propped up with cushions. She was intently
occupied in trimming a smart evening bodice. One glance
proved sufficient, to assure us that the lady was clever
with her fingers, for she turned and twisted the lace with
the audacious familiarity of a practised hand. It is said,
that could they but discover it, everyone is endowed with
a special gift; there are thousands of mortals who go
through life unconscious of their own capacities, but Mrs.
Wilkinson was one of those more fortunate beings who had
found her metier, and gloried in its exercise. She was an
accomplished milliner and a really firstclass dressmaker.
In all the province there was not a woman who could put in
a sleeve, tie a bow, or hang a skirt as well as Angel's
mamma. Once upon

<span id="pgepubid00014" title="[Pg 12]"></span>

a time—and that time not very distant—Mrs. Wilkinson
had been a beauty, but continuous hot seasons on the
plains, harassing money cares, and indifferent health had
combined to filch her of her good looks. There were hard
lines about her mouth, her cheeks had fallen in, and her
complexion—only appeared in the evening. Of course, in
early morning <i class="calibre11">deshabille</i> we do not expect to see a
lady at her best. Still, her carelessly arranged hair was
abundant, her features were delicate, and her blue eyes
had not yet lost the power of their spell. Black-lashed,
plaintive blue eyes, what had they not achieved for their
owner? How much she owes to them. What difficulties
surmounted, what favours granted—what friends! They
resembled in potency some fabled talisman; their mistress
had but to wish, look, and possess. Fortunately, Mrs.
Wilkinson's ambition was of a moderate character. She
merely desired to be the best-dressed woman in her circle,
that is to say station, and hitherto her pre-eminence had
been supreme.</p>
<p class="calibre7">"The Mrs. Wilkinson who dresses so well," enjoyed a fame
that went beyond the bounds of her own province, and had
even been echoed in much maligned Madras.</p>
<p class="calibre7">Just at present this celebrity, her eldest born, and her
faithful dirzee were labouring hard in order to maintain
this far-reaching reputation. The scene in which they
slaved was no bad imitation of the workroom of some smart
dressmaker. Chairs were piled with materials, the matting
was littered with scraps of lace, muslin, and calico;
patterns and fashion-plates lay scattered around, and in
the foreground

<span id="pgepubid00015" title="[Pg 13]"></span>

was a wicker dress-stand, surmounted by an exact model
of Mrs. Wilkinson's own graceful figure—a costly but
indispensable possession. At this moment it was attired in
an elaborate white ball skirt and low satin bodice, and at
a little distance appeared to be one of the party in the
verandah.</p>
<p class="calibre7">To slave for days, nay weeks, at her sewing machine, to
cut up, contrive and piece, scanty materials; to ponder
for hours over patterns, confer with an unimaginative
native, cope with failures, and plunge into debt, were a
few of the drawbacks to Mrs. Wilkinson's pre-eminence. But
inconvenience, anxiety, and self-denial were forgotten
when she appeared in an incomparable "success," conscious
of triumph, aware that she was the cynosure of all eyes,
and that even in church she absorbed the attention of half
the congregation. It is true that certain rivals, women
with ungrudging husbands, replenished their wardrobes from
London and Paris. Nevertheless, with even these, this
talented artiste was able to compete, for she was endowed
with the gift of wearing, as well as of designing, her
matchless toilettes. Her figure was slender and graceful,
and in a smart evening gown, with just the least little
touch on her cheeks, Mrs. Wilkinson still held her own in a
ballroom; her dancing was perfection, and, next to dress,
her sole passion.</p>
<p class="calibre7">As for the lady's past, despite her craze for dress
and dancing, it was extraordinarily monotonous, and
uneventful.</p>
<p class="calibre7">Miss Lena Shardlow, a charming but penniless orphan, had
arrived at Simla, some years before this

<span id="pgepubid00016" title="[Pg 14]"></span>

story opens, on a cold weather visit to distant relations,
who invited her out, in the benevolent hope that Lena's
pretty face would prove her fortune. If, as they afterwards
declared, she had played her cards properly, Lena might
have married a member of Council; it was true that he had
already seen the grave close over two wives, also that
he was neither young nor comely, but he could offer Lena
a splendid position as his wife, and a fine pension as
his widow. The girl had many admirers—indeed, she was
the success of the season. Among these admirers was Tony
Gascoigne, a feather-brained junior subaltern in the Silver
Hussars. Tony was handsome and well connected, but reckless
and impecunious. In an evil moment a brother officer
had advised him "not to make a fool of himself with the
little Shardlow girl," and the warning proved immediately
fatal. He married her within six weeks—her friends were
not present at the ceremony—and brought his lovely bride
down to Umballa in insuppressed triumph. Sad to relate,
this triumph proved but short-lived—it was cruelly slain
in the regimental orderly room, and died by the hand of
Tony's commanding officer. Colonel St. Oriel had a strong
prejudice against married subalterns, and a married
subaltern of a year's standing was only surpassed by the
notorious miscreant who had actually joined his regiment
with a wife and a perambulator.</p>
<p class="calibre7">It was whispered in the mess, that when "the old man"
received cards and cake, he had actually gnashed his teeth.
At any rate, the proud bridegroom was sent on detachment
within twenty-four hours. A year later, when Tony and his
wife were on leave in

<span id="pgepubid00017" title="Pg 15]"></span>

the hills, one wet black night, his pony lost his hind
legs over the brink of a slippery khud, and Tony's book
of life was closed at page twenty-three. He left a widow
and a puny infant in a cheap bungalow, not a hundred yards
from the scene of the tragedy. He also left many debts. At
first poor Mrs. Gascoigne was stunned, then inconsolable,
although her kind neighbours came forward to her assistance
in a fashion peculiar to India. For weeks she remained in
cloister-like seclusion, waiting for the monsoon to abate,
before returning to England, where it would be her fate to
live on distant relations and a pension of thirty pounds
a year. Ere three months had elapsed, it was noticed that
Major Wilkinson, of the Commissariat, despatched baskets
of tempting fruit and rare flowers to a certain retired
bungalow. These, as days went by, he boldly followed in
person, and long before the year was out, an engagement
was announced, and all the world of Dalhousie declared,
that little Mrs. Gascoigne had done remarkably well for
herself and her child. Major Wilkinson was neither young
nor dashing, he had also the reputation of being "careful
with his money." On the other hand, he was a sensible man,
with savings in the Bank of Bengal, and a small property in
New Zealand. The middle-aged Major was unmistakably in love
with the pretty blue-eyed widow, but, to impart a secret,
he had never exhibited the smallest enthusiasm for her
offspring, and now that he had four sturdy olive branches
of his own, indifference had developed into unconcealed
aversion. Perhaps (for he was a model parent) he may have
been a little jealous of his step-daughter's airy grace and

<span title="[Pg 16]"></span>

high-bred features. Angel was an aristocrat to the tips of
her shocking sand-shoes, whilst his own beloved progeny
were undeniably <i class="calibre11">bourgeois</i>—stumpy, stolid, heavy
children, whose faces recalled the colour and contour
of a cream cheese. Although Colonel Wilkinson scaled
sixteen stone, he was an active, bustling man—indeed some
people considered him "fussy"—an excellent organiser and
administrator in his official capacity, whilst at home
in the domestic circle he saw to everything himself,
thus relieving his Lena of all housekeeping cares. He
checked the bazaar accounts, gave out the stores, oil and
fodder, ordered the meals and hectored the servants—he
even instructed the ayah, and harried the milkman—the
only person over whom he had no control was the dirzee.
Consequently Lena had nothing to do but compose costumes,
amuse herself, and look pretty. In her heart of hearts,
Angel, her firstborn, was her mother's favourite child, but
no whisper of this weakness ever escaped her lips. She was
too painfully aware, that Richard was excessively jealous
of the claims of his family, whom he idolised.</p>
<p class="calibre7">Of course Angel ought to have been sent home, no one was
more alive to this duty than her parent, but unhappily Mrs.
Wilkinson had no private income; she was compelled to ask
for every rupee she expended, and it was with difficulty
she obtained a slender sum for the children's clothes. As
for her own toilettes, her husband liked to see her in
pretty gowns, he was proud of them, and of her, but when
it came to paying—oh! that was another affair altogether.
Every bill she presented to him entailed a

<span id="pgepubid00018" title="[Pg 17]"></span>

battle—or at least an argument, and what of those bills,
those frightful bills, she dared not let him see?</p>
<p class="calibre7">If Colonel Wilkinson growled savagely when called
upon to disburse for Angel's meagre wardrobe, how could
her mother hope for a substantial cheque to defray her
outfit, passage, and education? Much as Colonel Wilkinson
disliked the child, he had not the heart to open his purse
strings and provide for her removal to another home and
hemisphere.</p>
<p class="calibre7">Angel was naturally intelligent, and had picked up the
art of reading and writing, without perceptible labour.
The occasional lessons of an Eurasian schoolmistress
had introduced her to the multiplication table, and the
outlines of history and geography. She spoke Hindustani
with the facility and correctness of an Indian-born child.
She could sing the "Tazza Ba Tazza," and dance like a
nautch girl, and the servants alternately bullied and
feared her. They were all somewhat distrustful of "Missy
Angel." She knew too much—she was too wise.</p>
<p class="calibre7">As Angel sat on the floor of the verandah, her sharp
white face bent intently on the needle, her thin arm
tirelessly turning the handle of the sewing machine, her
thoughts were not with her task. She was wondering why the
ayah's sister happened to wear a jacket of similar stuff
to the piece which was sliding through her hands? Stolen
of course—how, and when? Oh, what a pig Anima was; and
it was late, and Philip had not come. Had he forgotten
his promise, he who never forgot a promise? She rose
stealthily, and went to a "chick," pulled it a little

<span id="pgepubid00019" title="[Pg 18]"></span>

aside and peered out. Nothing to be seen but the
brick-coloured compound, the sandy drive, the cork trees, a
quiver in the heated air.</p>
<p class="calibre7">"Missy Angel, what you doing?" screamed the ayah, "what
you looking for? Go back and sit down."</p>
<p class="calibre7">Angel returned to her post with noiseless steps, but as
she resumed her task, she held up the muslin towards the
ayah, and said:</p>
<p class="calibre7">"You see this, Anima? Some is stolen. I was only looking
for the thief. Do <i class="calibre11">you</i> know her?"</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?16996f80